import { call, put, takeLatest } from "redux-saga/effects";
import { httpGetQuizathonList } from "../../../services/quizathon";
import {
  getQuizathonFailure,
  getQuizathonStart,
  getQuizathonSuccess,
} from "../reducer";

export function* getQuizathonList({ payload }) {
  const response = yield call(httpGetQuizathonList, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(getQuizathonSuccess(raw));
  } else {
    yield put(getQuizathonFailure(message || raw.error));
  }
}

export default function* onGetQuizathonList() {
  yield takeLatest(getQuizathonStart.type, getQuizathonList);
}
